import React, { useState } from 'react';
import { Link } from "react-router-dom"

const Toolbar = ({
  categories = [],
  languages = [],
  onCategoryChange,
  onLanguageChange,
  onSearchChange,
  onCreateTemplate,
  isTempateFound,
  wabaId,
  phoneNumberId,
}) => {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [language, setLanguage] = useState('');
  const [options, setOptions] = useState('');
  const [timeRange, setTimeRange] = useState('');


  console.log("wabaId in toolbar", wabaId);
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setCategory(value);
    if (onCategoryChange) {
      onCategoryChange(value);
    }
  };

  const handleLanguageChange = (e) => {
    const value = e.target.value;
    setLanguage(value);
    if (onLanguageChange) {
      onLanguageChange(value);
    }
  };

  return (
    <div className="w-full border border-gray-300 rounded-lg mb-4 flex items-center justify-between flex-nowrap overflow-x-auto p-2 bg-white gap-4 min-h-16">
      {/* Left side filters */}
      <div className="flex gap-3 items-center flex-nowrap">
        {/* Search */}
        <input
          type="text"
          placeholder="Search templates..."
          value={search}
          onChange={handleSearchChange}
          className="px-3 py-2 text-sm border border-gray-400 rounded outline-none min-w-96"
        />

        {/* Category */}
        <select
          value={category}
          onChange={handleCategoryChange}
          className="px-3 py-2 text-sm border border-gray-400 rounded outline-none min-w-36 bg-white cursor-pointer text-gray-800"
        >
          <option value="">All Categories</option>
          {categories.map((cat, idx) => (
            <option key={idx} value={cat}>
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </option>
          ))}
        </select>

        {/* Language */}
        <select
          value={language}
          onChange={handleLanguageChange}
          className="px-3 py-2 text-sm border border-gray-400 rounded outline-none min-w-36 bg-white cursor-pointer text-gray-800"
        >
          <option value="">All Languages</option>
          {languages.map((lang, idx) => (
            <option key={idx} value={lang}>
              {lang.toUpperCase()}
            </option>
          ))}
        </select>

        {/* Last 7 */}
        <select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          className="px-3 py-2 text-sm border border-gray-400 rounded outline-none min-w-36 bg-white cursor-pointer text-gray-800"
        >
          <option value="">Last 7</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
        </select>
      </div>

      {/* Right side button */}
      {/* <Link to="/NewTemplate">

        <button
          className={`px-4 py-2 text-sm bg-blue-700 text-white border-none rounded cursor-pointer font-medium whitespace-nowrap hover:bg-blue-800 `}
        disabled={!isTempateFound}
          onClick={onCreateTemplate}
        >
          Create Template
        </button>
      </Link> */}

      <Link
        to={wabaId ? `/${wabaId}/${phoneNumberId}/NewTemplate` : "#"}
        onClick={(e) => {
          if (!wabaId || !isTempateFound) {
            e.preventDefault();
          }
        }}
      >
        <button
          disabled={!isTempateFound || !wabaId}
          className="px-4 py-2 text-sm bg-blue-700 text-white border-none rounded cursor-pointer font-medium whitespace-nowrap hover:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          Create Template
        </button>
      </Link>
    </div>
  );
};

export default Toolbar;